import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';

const AttendanceView = () => {
  const routes = all_routes;
  const [selectedMonth, setSelectedMonth] = useState('2024-07');

  // Mock data
  const mockAttendance = [
    { date: '2024-07-01', subject: 'Mathematics', status: 'Present', time: '09:00 AM' },
    { date: '2024-07-01', subject: 'Physics', status: 'Present', time: '10:00 AM' },
    { date: '2024-07-02', subject: 'Mathematics', status: 'Absent', time: '09:00 AM' },
    { date: '2024-07-02', subject: 'English', status: 'Present', time: '11:00 AM' },
    { date: '2024-07-03', subject: 'Physics', status: 'Late', time: '10:00 AM' }
  ];

  const attendanceStats = {
    totalDays: 20,
    present: 16,
    absent: 3,
    late: 1,
    percentage: 85
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Student Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">My Attendance</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="row">
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-success-transparent me-3">
                      <i className="ti ti-percentage"></i>
                    </div>
                    <div>
                      <h4>{attendanceStats.percentage}%</h4>
                      <p className="text-muted mb-0">Attendance Rate</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-primary-transparent me-3">
                      <i className="ti ti-check"></i>
                    </div>
                    <div>
                      <h4>{attendanceStats.present}</h4>
                      <p className="text-muted mb-0">Present</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-danger-transparent me-3">
                      <i className="ti ti-x"></i>
                    </div>
                    <div>
                      <h4>{attendanceStats.absent}</h4>
                      <p className="text-muted mb-0">Absent</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-warning-transparent me-3">
                      <i className="ti ti-clock"></i>
                    </div>
                    <div>
                      <h4>{attendanceStats.late}</h4>
                      <p className="text-muted mb-0">Late</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Attendance Details */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Attendance Details</h4>
                  <button className="btn btn-outline-primary btn-sm">
                    <i className="ti ti-download me-1"></i>Download Report
                  </button>
                </div>

                <div className="card-body border-bottom">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Select Month</label>
                      <input 
                        type="month" 
                        className="form-control"
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Filter by Subject</label>
                      <select className="form-select">
                        <option>All Subjects</option>
                        <option>Mathematics</option>
                        <option>Physics</option>
                        <option>English</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">&nbsp;</label>
                      <button className="btn btn-primary w-100">Apply Filter</button>
                    </div>
                  </div>
                </div>

                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to attendance API</h6>
                    <ul className="mb-0">
                      <li>Fetch student attendance records</li>
                      <li>Generate attendance reports</li>
                      <li>Show attendance patterns/trends</li>
                    </ul>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Subject</th>
                          <th>Time</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockAttendance.map((record, index) => (
                          <tr key={index}>
                            <td>{record.date}</td>
                            <td>{record.subject}</td>
                            <td>{record.time}</td>
                            <td>
                              <span className={`badge ${
                                record.status === 'Present' ? 'badge-soft-success' :
                                record.status === 'Absent' ? 'badge-soft-danger' :
                                'badge-soft-warning'
                              }`}>
                                {record.status}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceView;
